import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import solicitarBaixaMeiSelector from "../store/solicitarBaixaMei.selectors";
import solicitarBaixaMeiActions from "../store/solicitarBaixaMei.actions";
import autoBind from "react-autobind";
import StaticGrid from "@common/components/grid/staticGrid.component";
import * as typeArray from "@/modules/common/app/helpers/grid.typeArray";
import Button from "@material-ui/core/Button";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "RedeSIM.SolicitarBaixaMei",
      applySearchOnLoad: true,
      isNotCheckable: true,
    };

    const columns = [
      {
        fieldName: "Cnpj",
        dataName: "CnpjEmpresa",
        show: true,
        type: "text",
        removeFilter: true,
      },
      {
        fieldName: "Nome Empresa",
        dataName: "NomeEmpresa",
        show: true,
        type: "text",
        removeFilter: true,
      },
      {
        fieldName: "Tipo Empresa",
        dataName: "TipoEmpresa",
        show: true,
        type: "text",
        removeFilter: true,
      },
      {
        fieldName: "Ccm",
        dataName: "Ccm",
        show: true,
        type: "number",
        removeFilter: true,
      },
      {
        fieldName: "Situação Ccm",
        dataName: "SituacaoCcm",
        show: true,
        type: "text",
        removeFilter: true,
      },
    ];

    const actions = [
      {
        title: "Solicitar Baixa MEI",
        icon: "fas fa-check",
        onClick: async (dataItem) => {
          this.props.solicitarBaixaMeiActions.selecionarSolicitarBaixaMei(
            dataItem
          );
        },
      },
    ];

    const order = [{ fieldName: "Cnpj", dataName: "CnpjEmpresa", order: "A" }];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false,
      },
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar,
    };
  }

  onClose() {
    this.props.solicitarBaixaMeiActions.setSolicitarBaixaMei({
      SolicitacaoBaixaMeiDados: [],
      GridSolicitarBaixaMeiPesquisa: [],
      SolicitarBaixaMeiModalToggle: false,
    });
  }

  render() {
    const { solicitarBaixaMei } = this.props.solicitarBaixaMeiSelector;
    const { GridSolicitarBaixaMeiPesquisa } = solicitarBaixaMei;

    return (
      <>
        <StaticGrid
          {...this.config}
          itens={GridSolicitarBaixaMeiPesquisa.asMutable()}
        ></StaticGrid>
        <div style={{ textAlign: "right" }}>
          <Button variant="outlined" color="primary" onClick={this.onClose}>
            <i className={"mr-1 fa fa-angle-double-left"} /> {"Voltar"}
          </Button>
        </div>
      </>
    );
  }
}

export default connect({
  actions: {
    solicitarBaixaMeiActions,
  },
  selectors: {
    solicitarBaixaMeiSelector,
  },
})(Container);
